import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getCurrentTime16j9973nx5x63 as getCurrentTime } from './internal/KLoggingClock.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var KLoggingEventClass;
function KLoggingEvent() {
  if (KLoggingEventClass === VOID) {
    class $ {
      constructor(level, marker, loggerName, message, cause, payload, timestamp) {
        return new.target.g2i(level, marker, loggerName, message, cause, payload, timestamp);
      }
      static g2i(level, marker, loggerName, message, cause, payload, timestamp) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        payload = payload === VOID ? null : payload;
        timestamp = timestamp === VOID ? getCurrentTime() : timestamp;
        var $this = createThis(this);
        $this.n2h_1 = level;
        $this.o2h_1 = marker;
        $this.p2h_1 = loggerName;
        $this.q2h_1 = message;
        $this.r2h_1 = cause;
        $this.s2h_1 = payload;
        $this.t2h_1 = timestamp;
        return $this;
      }
      static h2i(level, marker, loggerName, eventBuilder) {
        return this.g2i(level, marker, loggerName, eventBuilder.y2h_1, eventBuilder.z2h_1, eventBuilder.a2i_1);
      }
      toString() {
        return 'KLoggingEvent(level=' + this.n2h_1.toString() + ', marker=' + toString(this.o2h_1) + ', loggerName=' + this.p2h_1 + ', message=' + this.q2h_1 + ', cause=' + toString(this.r2h_1) + ', payload=' + toString(this.s2h_1) + ', timestamp=' + this.t2h_1.toString() + ')';
      }
      hashCode() {
        var result = this.n2h_1.hashCode();
        result = imul(result, 31) + (this.o2h_1 == null ? 0 : hashCode(this.o2h_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.p2h_1) | 0;
        result = imul(result, 31) + (this.q2h_1 == null ? 0 : getStringHashCode(this.q2h_1)) | 0;
        result = imul(result, 31) + (this.r2h_1 == null ? 0 : hashCode(this.r2h_1)) | 0;
        result = imul(result, 31) + (this.s2h_1 == null ? 0 : hashCode(this.s2h_1)) | 0;
        result = imul(result, 31) + getBigIntHashCode(this.t2h_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KLoggingEvent()))
          return false;
        var tmp0_other_with_cast = other instanceof KLoggingEvent() ? other : THROW_CCE();
        if (!this.n2h_1.equals(tmp0_other_with_cast.n2h_1))
          return false;
        if (!equals(this.o2h_1, tmp0_other_with_cast.o2h_1))
          return false;
        if (!(this.p2h_1 === tmp0_other_with_cast.p2h_1))
          return false;
        if (!(this.q2h_1 == tmp0_other_with_cast.q2h_1))
          return false;
        if (!equals(this.r2h_1, tmp0_other_with_cast.r2h_1))
          return false;
        if (!equals(this.s2h_1, tmp0_other_with_cast.s2h_1))
          return false;
        if (!(this.t2h_1 === tmp0_other_with_cast.t2h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'KLoggingEvent');
    KLoggingEventClass = $;
  }
  return KLoggingEventClass;
}
//region block: exports
export {
  KLoggingEvent as KLoggingEvent3el01063mcenm,
};
//endregion

//# sourceMappingURL=KLoggingEvent.mjs.map
